import type { Overview, RouteCorridor } from "../types";

const now = new Date().toISOString();

export const demoRoutes: RouteCorridor[] = [
  {
    id: 1,
    code: "CHIH-MTY",
    name: "Chihuahua → Monterrey",
    status: "active",
    corridor_width_m: 1500,
    path_json: [[-106.09, 28.63], [-105.66, 26.92], [-103.42, 25.54], [-100.31, 25.68]],
    active: true,
    metadata_json: { source: "demo" },
  },
  {
    id: 2,
    code: "GDL-CDMX",
    name: "Guadalajara → CDMX",
    status: "active",
    corridor_width_m: 1500,
    path_json: [[-103.35, 20.67], [-101.1, 20.14], [-99.13, 19.43]],
    active: true,
    metadata_json: { source: "demo" },
  },
  {
    id: 3,
    code: "VER-PUE",
    name: "Veracruz → Puebla",
    status: "warning",
    corridor_width_m: 1500,
    path_json: [[-96.13, 19.17], [-96.89, 19.27], [-98.2, 19.04]],
    active: true,
    metadata_json: { source: "demo" },
  },
  {
    id: 4,
    code: "MID-VSA",
    name: "Mérida → Villahermosa",
    status: "active",
    corridor_width_m: 1500,
    path_json: [[-89.62, 20.97], [-90.53, 19.84], [-92.93, 17.99]],
    active: true,
    metadata_json: { source: "demo" },
  },
];

export const demoOverview: Overview = {
  metrics: {
    total: 4,
    online: 1,
    warning: 1,
    critical: 1,
    offline: 1,
    moving: 3,
    open_alerts: 2,
  },
  vehicles: [
    {
      id: 1,
      unit_code: "TRACTO-042",
      name: "Centinela Norte",
      vehicle_type: "dry_van",
      make: "Freightliner",
      model: "Cascadia",
      year: 2024,
      plate: "45-AR-2X",
      imei: "350000000000042",
      status: "critical",
      driver_name: "Luis Mendoza",
      route_name: "Chihuahua → Monterrey",
      latitude: 26.928,
      longitude: -105.665,
      speed_kph: 82,
      heading: 118,
      fuel_percent: 67,
      odometer_km: 284102,
      last_seen: now,
      metadata_json: { trailer: "REM-204", cargo: "Electrónica" },
    },
    {
      id: 2,
      unit_code: "TRACTO-018",
      name: "Águila Centro",
      vehicle_type: "reefer",
      make: "Kenworth",
      model: "T680",
      year: 2023,
      plate: "19-BC-8K",
      imei: "350000000000018",
      status: "online",
      driver_name: "María Castañeda",
      route_name: "Guadalajara → CDMX",
      latitude: 20.144,
      longitude: -101.104,
      speed_kph: 74,
      heading: 101,
      fuel_percent: 81,
      odometer_km: 192440,
      last_seen: now,
      metadata_json: { trailer: "REF-089", cargo: "Cadena fría" },
    },
    {
      id: 3,
      unit_code: "PIPA-007",
      name: "Halcón Golfo",
      vehicle_type: "tanker",
      make: "International",
      model: "LT",
      year: 2022,
      plate: "82-XD-1R",
      imei: "350000000000007",
      status: "warning",
      driver_name: "Óscar Ruiz",
      route_name: "Veracruz → Puebla",
      latitude: 19.275,
      longitude: -96.893,
      speed_kph: 38,
      heading: 278,
      fuel_percent: 43,
      odometer_km: 344028,
      last_seen: now,
      metadata_json: { trailer: "PIP-007", cargo: "Combustible" },
    },
    {
      id: 4,
      unit_code: "TRACTO-031",
      name: "Jaguar Sureste",
      vehicle_type: "dry_van",
      make: "Volvo",
      model: "VNL",
      year: 2024,
      plate: "33-YY-4M",
      imei: "350000000000031",
      status: "offline",
      driver_name: "Enrique Solís",
      route_name: "Mérida → Villahermosa",
      latitude: 20.012,
      longitude: -89.202,
      speed_kph: 0,
      heading: 245,
      fuel_percent: 55,
      odometer_km: 98110,
      last_seen: now,
      metadata_json: { trailer: "REM-155", cargo: "Paquetería" },
    },
  ],
  alerts: [
    {
      id: 1,
      vehicle_id: 1,
      alert_type: "tpms_low_pressure",
      severity: "critical",
      title: "Presión crítica en llanta",
      description: "Eje 3 exterior derecha · 71 PSI / objetivo 100 PSI",
      component_code: "tire_axle_3_right_outer",
      status: "open",
      created_at: now,
    },
    {
      id: 2,
      vehicle_id: 3,
      alert_type: "fuel_drop",
      severity: "warning",
      title: "Descenso irregular de combustible",
      description: "Caída de 7% en 10 minutos",
      component_code: "fuel_tank_left",
      status: "open",
      created_at: now,
    },
  ],
  cameras: [
    { id: 1, vehicle_id: 1, name: "Frontal", channel: "front", provider: "simulated", stream_url: null, online: true },
    { id: 2, vehicle_id: 1, name: "Cabina DSM", channel: "cabin", provider: "simulated", stream_url: null, online: true },
    { id: 3, vehicle_id: 2, name: "Frontal", channel: "front", provider: "simulated", stream_url: null, online: true },
    { id: 4, vehicle_id: 3, name: "Lateral", channel: "side", provider: "simulated", stream_url: null, online: true },
  ],
  latest_sensors: [
    {
      id: 1,
      vehicle_id: 1,
      sensor_code: "tpms_axle_3_right_outer",
      component_code: "tire_axle_3_right_outer",
      value: 71,
      text_value: null,
      unit: "PSI",
      severity: "critical",
      captured_at: now,
      metadata_json: { target: 100, temperature_c: 84 },
    },
    {
      id: 2,
      vehicle_id: 2,
      sensor_code: "reefer_zone_front",
      component_code: "cargo_zone_front",
      value: 3.8,
      text_value: null,
      unit: "°C",
      severity: "normal",
      captured_at: now,
      metadata_json: { target: 4 },
    },
    {
      id: 3,
      vehicle_id: 3,
      sensor_code: "fuel_primary",
      component_code: "fuel_tank_left",
      value: 43,
      text_value: null,
      unit: "%",
      severity: "warning",
      captured_at: now,
      metadata_json: { drop_percent_10m: 7 },
    },
    {
      id: 4,
      vehicle_id: 3,
      sensor_code: "engine_coolant_temperature",
      component_code: "engine_main",
      value: 91,
      text_value: null,
      unit: "°C",
      severity: "normal",
      captured_at: now,
      metadata_json: { warning_above: 102, critical_above: 110 },
    },
    {
      id: 5,
      vehicle_id: 3,
      sensor_code: "air_brake_primary_pressure",
      component_code: "air_brake_primary",
      value: 8.2,
      text_value: null,
      unit: "bar",
      severity: "normal",
      captured_at: now,
      metadata_json: { warning_below: 6.5, critical_below: 5.5 },
    },
    {
      id: 6,
      vehicle_id: 3,
      sensor_code: "tpms_axle_3_right_outer",
      component_code: "tire_axle_3_right_outer",
      value: 102,
      text_value: null,
      unit: "PSI",
      severity: "normal",
      captured_at: now,
      metadata_json: { target: 100, temperature_c: 48 },
    },
    {
      id: 7,
      vehicle_id: 3,
      sensor_code: "hub_temperature_axle_3_right",
      component_code: "hub_axle_3_right",
      value: 46,
      text_value: null,
      unit: "°C",
      severity: "normal",
      captured_at: now,
      metadata_json: { warning_above: 85, critical_above: 105 },
    },
    {
      id: 8,
      vehicle_id: 3,
      sensor_code: "tank_cargo_level",
      component_code: "cargo_zone_middle",
      value: 78,
      text_value: null,
      unit: "%",
      severity: "normal",
      captured_at: now,
      metadata_json: { capacity_liters: 30000 },
    },
  ],
};
